import { type IAttribute } from '../store/slices/SurveyTemplateSlice'
import { type DataObject, type DataObjectList, type ICreatedBy, type IModifiedBy, type IOwnedBy } from './DataObject'
import { type SurveyQuestionType } from './Survey'

export interface IOption {
  option: string
  weight: number | null
}

export enum SurveyItemQuestionType {
  FREE_RESPONSE = 'FreeResponse',
  LINEAR_SCALE = 'LinearScale',
  MULTIPLE_CHOICE = 'MultipleChoice',
  DESCRIPTIVE_TEXT = 'DescriptiveText',
  TITLE = 'Title',
}

export interface SurveyInstructorDetails {
  id: string
  title: string
}

export interface SectionBranchingFilters {
  answer: null | string[]
  itemId: string
  itemType: string
  operation: string
  prompt: string
}

export interface ISurveyItem extends ICreatedBy, IOwnedBy, IModifiedBy {
  archivedOn: string | null
  hashedPrompt: string | null
  isArchived: boolean
  isRequired: boolean
  itemId: string
  itemType: SurveyQuestionType
  nextRevision: string | null
  object: IOption[] | string[] | null
  prevRevision: string | null
  prompt: string
  revision: number
  branchingFilters: any
}

export interface ISurveySection extends ICreatedBy, IOwnedBy, IModifiedBy {
  archivedOn: string | null
  descr: string | null
  isArchived: boolean
  name: string
  nextRevision: string | null
  prevRevision: string | null
  questionCount: number
  revision: number
  surveyItems: ISurveyItem[]
  surveySectionId: string
  title: string | null
  isRepeatPerInstructor: boolean
  instructorName: string
  instructorId: string
  attributes: IAttribute[]
  branchingFilters: any
  parentSurveySectionId?: string
  surveySectionRevision?: number
  indentation: number
}

export interface ISurveyTemplate extends ICreatedBy, IOwnedBy, IModifiedBy {
  archivedOn: string | null
  descr: string | null
  isArchived: boolean
  nextRevision: string | null
  prevRevision: string | null
  questionCount: number
  revision: number
  sectionCount: number
  surveySections: ISurveySection[]
  templateId: string
  distributionSeriesTitle: string
  sectionAbbreviation: string
  instructors: SurveyInstructorDetails[]
  title: string
}

export type ISurveyTemplateRow = ISurveyTemplate

export type ISurveyTemplateList = DataObject<ISurveyTemplate>

export type ISurveyTemplateRowDataType = ISurveyTemplateList[]

export type ISurveyTemplateListResponse = DataObjectList<ISurveyTemplate>
